import Link from 'next/link'
import { ComponentType, SVGProps } from 'react'

import { Icon } from '@/shared/ui/icon'

import styles from './SocialItem.module.scss'

export type SocialItemProps = {
	href: string
	iconId: ComponentType<SVGProps<SVGSVGElement>>
	title: string
}

export const SocialItem = ({ href, iconId, title }: SocialItemProps): JSX.Element => (
	<div className={styles.socialItem}>
		<Link prefetch={false} href={href} className={styles.link} title={title} target="_blank" rel="noreferrer">
			<Icon icon={iconId} width={38} height={38} />
		</Link>
	</div>
)
